'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var IconButtonWithDropDown = require('../../../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
var ListItemText = _interopDefault(require('@material-ui/core/ListItemText'));
var MoreVert = _interopDefault(require('@material-ui/icons/MoreVert'));
var utils = require('./utils.js');
var styledComponents = require('./styled-components.js');

var SelectConversationListElement = function (props) {
    var onClickDelete = props.onClickDelete, onClickRead = props.onClickRead, read = props.read, latestMessageText = props.latestMessageText, name = props.name, latestMessageTime = props.latestMessageTime, onClickSelect = props.onClickSelect, selected = props.selected;
    var readText = read ? 'Mark Unread' : 'Mark Read';
    return (React__default.createElement(styledComponents.StyledMListItem, { selected: selected, button: true },
        React__default.createElement(ListItemText, { onClick: onClickSelect, primary: React__default.createElement(Grid, { container: true, alignItems: 'stretch' },
                React__default.createElement(Grid, { item: true, xs: 6 },
                    React__default.createElement(styledComponents.StyledMainTypography, { read: read, color: 'textPrimary' }, name)),
                React__default.createElement(Grid, { item: true, xs: 6 },
                    React__default.createElement(styledComponents.StyledTimeTypography, { read: read, align: 'right' }, utils.convertTime(latestMessageTime)))), secondary: React__default.createElement(React__default.Fragment, null,
                React__default.createElement(styledComponents.StyledSubTypography, { read: read, noWrap: true },
                    read && React__default.createElement(styledComponents.StyledCheckIcon, null),
                    " ",
                    latestMessageText)) }),
        React__default.createElement(styledComponents.StyledItemAvatar, null,
            React__default.createElement(IconButtonWithDropDown, { id: 'conversation_list_actions', menuItems: [
                    { text: readText, clickHandler: onClickRead },
                    { text: 'Delete', clickHandler: onClickDelete },
                ], Icon: MoreVert }))));
};

module.exports = SelectConversationListElement;
